import { render, staticRenderFns } from "./depart.vue?vue&type=template&id=1a7a13c3&scoped=true&"
import script from "./depart.vue?vue&type=script&lang=js&"
export * from "./depart.vue?vue&type=script&lang=js&"
import style0 from "./depart.vue?vue&type=style&index=0&id=1a7a13c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a13c3",
  null
  
)

export default component.exports